import { Component, computed, OnDestroy, OnInit, signal } from '@angular/core';
import { AppModule } from '../../app.module';
import { IncidentService } from '../../shared/incident.service';
import { NotificationService } from '../../shared/notification.service';
import { Router } from '@angular/router';
import { SharedDataService } from '../../shared/shareddata.service';
import { WhatsappService } from '../../whatsapp/whatsapp.service';
import { IncidentStatusCategory } from '../../shared/enums';
import { AuthService } from '../../auth.service';
import { MapIncidents } from "../../map/map-incidents/map-incidents";
import { Incident } from '../../models/incident';
import { Stats } from "../stats/stats";
import { OpenIncidentTable } from "../../incident/open-incident-table/open-incident-table";
import { interval, Subscription } from 'rxjs';

@Component({
  selector: 'app-callcentre-dash',
  imports: [AppModule, OpenIncidentTable, MapIncidents],
  templateUrl: './callcentre-dash.html',
  styleUrl: './callcentre-dash.less'
})
export class CallcentreDash implements OnInit, OnDestroy {


  IncidentStatusCategory = IncidentStatusCategory;
  operatorIncidents = computed(() => this.incidentService.openIncidents());
  isMapVisible = signal(false);

  toggleMap(): void {
    this.isMapVisible.update(v => !v);
  }
  etaChanges = signal<Map<number, number>>(new Map());
  private etaUpdateSubscription: Subscription;

  private refreshSubscription: Subscription;
  private readonly REFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes

  public incidentSelected = signal<Incident | null>(null);
  
  constructor(
    public incidentService: IncidentService, 
    public notification: NotificationService,
    public router: Router,
    public sharedDataService: SharedDataService,
    public whatsappService: WhatsappService,
    private authService: AuthService
  ) { }
  
  ngOnInit(): void {
    // this.loadData();
    this.setupAutoRefresh();
    this.setupEtaUpdates();
  }

  ngOnDestroy(): void {
    //cleanup if needed
    this.etaUpdateSubscription?.unsubscribe();
    this.refreshSubscription?.unsubscribe();
  }

  private loadData() {
    this.incidentService.loadOperatorIncidents()
      .subscribe({
        next: (incidents) => {
          //this.operatorIncidents.set(incidents);
        },
        error: (error) => {
          this.notification.handleError(error, 'Failed to load breakdowns');
        }
      });
  }

  private setupAutoRefresh(): void {
    this.refreshSubscription = interval(this.REFRESH_INTERVAL).subscribe(() => {
      this.loadData();
    });
  }

  private setupEtaUpdates(): void {     
    this.etaUpdateSubscription = this.incidentService.$etaUpdate.subscribe((etaUpdate) => {
      //find the incident in the operatorIncidents list and update its ETA
      const incident = this.operatorIncidents().find(i => i.incidentId === etaUpdate.incidentId);
      if (incident) {
        // Calculate the difference in minutes
        const oldEta = new Date(incident.breakdownTechnicianDriverEta);
        const newEta = new Date(etaUpdate.newEta);
        const diffInMinutes = Math.round((newEta.getTime() - oldEta.getTime()) / (1000 * 60));
        
        // Update the incident's ETA
        incident.breakdownTechnicianDriverEta = etaUpdate.newEta;
        
        // Create a new array to trigger signal update
       // this.operatorIncidents.set([...this.operatorIncidents()]);
       //this.incidentService.updateIncidentEta(etaUpdate.incidentId, etaUpdate.newEta);
        
        // Store the ETA change for visual indicator
        const currentChanges = new Map(this.etaChanges());
        currentChanges.set(etaUpdate.incidentId, diffInMinutes);
        this.etaChanges.set(currentChanges);
        
        // Remove the indicator after 10 seconds
        setTimeout(() => {
          const updatedChanges = new Map(this.etaChanges());
          updatedChanges.delete(etaUpdate.incidentId);
          this.etaChanges.set(updatedChanges);
        }, 10000);
      }
    });
  }

  public onClickNewBreakdowns() {
    //get the incidentid of the top item in the list
    
    const incidentId = this.incidentService.getFirstNewIncidentId(this.authService.user?.clientId);
    if (incidentId) {
      this.router.navigate(['/incident', incidentId]);
    }
  }

  public onClickAllBreakdowns() {
    this.router.navigate(['/incidents']);
  }

  public get newIncidentCount(): number {
    return this.incidentService.getOperatorStats(this.authService.user?.clientId).newIncidentCount;
  }

  public get openIncidentCount(): number {
    return this.incidentService.getOperatorStats(this.authService.user?.clientId).openIncidentCount;
  }

  public onIncidentSelected(incident: Incident | null): void {
    this.incidentSelected.set(incident);
  }

}
